export const PROJECT_PAGE_SIZE = 10;
export const NOT_APPLICABLE = 'NOT_APPLICABLE';
